import { ENV_VARS } from 'constants/environment.constants';
import { HttpStatusCode } from 'constants/http-statuscodes';
import { kf1AuthenticatedHttpClient } from 'kfone-frontend-core';
import { fileDownloadHelper } from 'utilities';
import { getTimeStamp } from 'utilities/helper';
const apiURL = ENV_VARS.API_URL;
const apiUrlFileDownload = ENV_VARS.API_URL + 'dataload/downloadtemplate';
const editFileAPI = ENV_VARS.API_URL + 'dataload/offlinedatavalidate';

export interface IGetCountryListProps {
  reportName: string;
  countryCode: string | undefined;
  reportId: string | number;
  fileName: string;
  extension: string;
  file: Blob | File;
  isValid: boolean;
  isOfflineValidate?: boolean;
}

export const fileUpload = async (props: IGetCountryListProps): Promise<any> => {
  const {
    reportName,
    countryCode,
    reportId,
    fileName,
    extension,
    file,
    isValid,
    isOfflineValidate,
  } = props;
  const urlQuery = `dataload/upload?reportName=${reportName}&countryCode=${countryCode}&reportId=${reportId}&fileName=${fileName}&extension=${extension}&isValid=${isValid}&isOfflineValidate=${isOfflineValidate}`;
  if (!props) {
    throw new Error('Props are required');
  }
  const formData = new FormData();
  formData.append('file', file);
  try {
    const response: any = await kf1AuthenticatedHttpClient({
      baseURL: apiURL,
      url: urlQuery,
      method: 'POST',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error: any) {
    // Type guard to check if error is an axios error with response
    if (error.message == 'Request timed out' || error.status == HttpStatusCode.GatewayTimeout) {
      return {
        responseCode: 408,
        responseMessage: 'Something went wrong. Please try uploading again.',
      };
    }

    if (error && typeof error === 'object' && 'response' in error) {
      const axiosError = error as { response?: { data?: { responseCode?: number } } };
      if (
        axiosError.response &&
        (axiosError.response.data?.responseCode === 400 ||
          axiosError.response.data?.responseCode === 422)
      ) {
        return axiosError.response.data;
      }
      if (error.status === HttpStatusCode.InternalServerError) {
        return {
          responseCode: 500,
          responseMessage: 'Something went wrong. Please try uploading again.',
        };
      }
    }
  }
};

export const downloadFileService = async (
  countryCode: string,
  templateName: string,
): Promise<any> => {
  const urlQuery = apiUrlFileDownload + `?countryCode=${countryCode}&template=${templateName}`;
  try {
    const response = await kf1AuthenticatedHttpClient({
      baseURL: urlQuery,
      method: 'GET',
      responseType: 'blob',
    });
    const fileBlob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const fileObj = {
      file: fileBlob,
      fileName: `report_template-${getTimeStamp()}.xlsx`,
    };
    fileDownloadHelper(fileObj);
    return fileBlob;
  } catch (error) {
    console.error('Error fetching country list:', error);
    throw error;
  }
};

export const downloadEditFileService = async (reportId: number): Promise<any> => {
  const urlQuery = editFileAPI + `?reportId=${reportId}`;
  try {
    const response = await kf1AuthenticatedHttpClient({
      baseURL: urlQuery,
      method: 'GET',
      responseType: 'blob',
    });
    const fileBlob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const fileObj = {
      file: fileBlob,
      fileName: `EditDataUpload-${getTimeStamp()}.xlsx`,
    };
    fileDownloadHelper(fileObj);
    return fileBlob;
  } catch (error) {
    console.error('Error fetching country list:', error);
    throw error;
  }
};

export const getReportErrors = async (reportId: number): Promise<any> => {
  try {
    const config = {
      url: 'report/nifireportstatus?reportId=' + reportId,
      method: 'GET',
      baseURL: ENV_VARS.API_URL,
    };
    const res = await kf1AuthenticatedHttpClient(config);
    return res.data;
  } catch (error) {
    console.error('Error fetching country list:', error);
    throw error;
  }
};
